var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ol-popup",style:({'min-width': '50px'})},_vm._l((_vm.idents),function(ident){return _c('b-row',{key:ident},[_c('b-col',[_c('b-button',{key:ident,attrs:{"size":"sm","variant":"outline-primary"},on:{"click":function($event){return _vm.emitValue(ident)}}},[_vm._v(_vm._s(ident))])],1)],1)}),1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d4734b94","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/map/designotron/MultiPopup.vue
// module id = null
// module chunks = 